import vsComponent from './vsTooltip'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
